export const actionsRecurring = {
  data() {
    return {
      organizationId: null,
      originOrganizationId: null,
      targetOrganizationId: null,
    }
  },

  created() {
    this.organizationId = this.$route.params.targetOrganizationId || this.$route.params.organizationId
    this.targetOrganizationId = this.$route.params.targetOrganizationId || this.$route.params.organizationId
    this.originOrganizationId = this.$route.params.targetOrganizationId ? this.$route.params.organizationId : null
  },

  mounted() {
    this.$root.$on('update-close-popup', () => {
      this.closePopUp(true)
    })
  },

  beforeDestroy() {
    clearInterval(this.intervalTime)
    this.$root.$off('update-close-popup')
  },

  methods: {
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },

    closePopUp(all = false, modal) {
      this.$store.commit('backOffice/CLOSE_ALL_MODAL', { all, modal })
    },

    toggleDelete(item) {
      if (!item._modalDelete) {
        this.closePopUp(true)
        this.$store.commit('backOffice/TOGGLE_MODAL', { item, modal: '_modalDelete' })
        return
      }

      this.$store.commit('backOffice/TOGGLE_MODAL', { item, modal: '_modalDelete' })
    },

    closeAllModalInputValue() {
      this?.itemsDataTableRecurrent?.forEach((elem) => {
        this.$set(elem, '_modalChangeValue', false)
        this.$set(elem, '_modalTypeValueActive', false)
        this.$set(elem, '_currentBalanceTemp', 0)
        this.$set(elem, '_modalDelete', false)
      })
    },

    toggleInputValueSubscription({ item }) {
      if (item._modalChangeValue) {
        this.$store.commit('backOffice/TOGGLE_MODAL', { item, modal: '_modalChangeValue' })
        return
      }
      this.closePopUp(true)
      this.$store.commit('backOffice/TOGGLE_MODAL', { item, modal: '_modalChangeValue' })
    },

    toggleInputValue({ item, type }) {
      if (item._modalChangeValue) {
        this.$store.commit('backOffice/TOGGLE_MODAL', { item, modal: '_modalChangeValue', type })
        return
      }
      this.closePopUp(true)
      this.$store.commit('backOffice/TOGGLE_MODAL', { item, modal: '_modalChangeValue', type })
    },

    addRecurring(item) {
      this.closePopUp(true)

      this.$store
        .dispatch('backOffice/addRecurring', {
          item,
          organizationId: this.organizationId,
          originOrganizationId: this.originOrganizationId,
          targetOrganizationId: this.targetOrganizationId,
        })
        .then((resp) => {
          const _message = {
            dismissCountDown: resp ? 3 : false,
            text: this.$t('general.tables.message.success.successfully-added'),
            status: 'success',
          }

          const newItem = {
            id: resp,
            _channel: item._channel,
            _typeTable: item._typeTable,
            _message,
          }

          this.$store.commit('backOffice/MESSAGE_REQUEST', newItem)
        })
        .catch((resp) => {
          const _message = {
            dismissCountDown: resp ? 3 : false,
            text: this.$t(`general.errors.${resp}`),
            status: 'danger',
          }

          const newItem = {
            id: item.id || item._tempId,
            _channel: item._channel,
            _typeTable: item._typeTable,
            _message,
          }

          this.$store.commit('backOffice/MESSAGE_REQUEST', newItem)
        })
        .finally(() => {})
    },

    updateRecurring(item) {
      this.closePopUp(true)

      item.organizationId = this.organizationId
      item.originOrganizationId = this.originOrganizationId
      item.targetOrganizationId = this.targetOrganizationId

      this.$store
        .dispatch('backOffice/updateRecurring', { item })
        .then((resp) => {
          const _message = {
            dismissCountDown: 3,
            text: this.$t('general.tables.message.success.successfully-added'),
            status: 'success',
          }

          const newItem = {
            id: resp || item.id,
            index: item.index,
            _channel: item._channel,
            _typeTable: item._typeTable,
            _message,
          }

          this.$store.commit('backOffice/MESSAGE_REQUEST', newItem)
        })
        .catch((resp) => {
          const _message = {
            dismissCountDown: resp ? 3 : false,
            text: this.$t(`general.errors.${resp}`),
            status: 'danger',
          }

          const newItem = {
            id: item.id,
            index: item.index,
            _channel: item._channel,
            _typeTable: item._typeTable,
            _message,
          }

          this.$store.commit('backOffice/MESSAGE_REQUEST', newItem)
        })
        .finally(() => {})
    },

    removeRecurring(item) {
      this.closePopUp(true)

      if (item._tempId) {
        this.$store.commit('backOffice/REMOVE_REGISTER', { item })
        return
      }

      if (item.id) {
        this.$store.dispatch('backOffice/removeRecurring', {
          channel: this.channel,
          targetOrganizationId: this.targetOrganizationId,
          organizationId: this.organizationId,
          addOnOrganizationChannelId: item.id,
        })
        return
      }
    },

    removeBalance(item) {
      this.closePopUp(true)

      if (item._tempId) {
        this.$store.commit('backOffice/REMOVE_REGISTER', { item })
        return
      }

      if (item.id) {
        this.$store.dispatch('backOffice/removeBalance', {
          channel: this.channel,
          organizationId: this.organizationId,
          countryId: item?.countryId,
          originOrganizationId: this.originOrganizationId,
          targetOrganizationId: this.targetOrganizationId,
        })
        return
      }
    },

    incrementOrDecrementBalance(item) {
      this.closePopUp(true)

      item.organizationId = this.organizationId
      item.originOrganizationId = this.originOrganizationId
      item.targetOrganizationId = this.targetOrganizationId

      this.$store
        .dispatch('backOffice/incrementOrDecrementBalance', item)
        .then((resp) => {
          const _message = {
            dismissCountDown: resp ? 3 : false,
            text: this.$t('general.tables.message.success.successfully-added'),
            status: 'success',
          }

          const newItem = {
            id: item.id || resp,
            _channel: item._channel,
            _typeTable: item._typeTable,
            _message,
          }

          this.$store.commit('backOffice/MESSAGE_REQUEST', newItem)
        })
        .catch((resp) => {
          const ERROR = resp.response.data || false

          const _message = {
            dismissCountDown: ERROR ? 3 : false,
            text: ERROR == false ? this.$t(`general.errors.${ERROR.UNEXPECTED}`) : this.$t(`general.errors.${ERROR.message}`),
            status: 'danger',
          }

          const newItem = {
            id: item.id || item._tempId,
            _channel: item._channel,
            _typeTable: item._typeTable,
            _message,
          }

          this.$store.commit('backOffice/MESSAGE_REQUEST', newItem)
        })
        .finally(() => {})
    },
  },
}
